var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStsFuel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9028 13.934C14.3379 14.6551 13.6147 15.2387 12.7883 15.64C11.9619 16.0414 11.0541 16.25 10.1342 16.25H2.51813C2.11757 16.25 1.73342 16.092 1.45018 15.8107C1.16694 15.5294 1.00781 15.1478 1.00781 14.75V9.5C1.00781 9.10218 1.16694 8.72064 1.45018 8.43934C1.73342 8.15804 2.11757 8 2.51813 8H8.78496C9.12793 8.0001 9.46066 8.11613 9.72841 8.329L12.4863 10.516C12.6745 10.6655 12.896 10.7682 13.1323 10.8153C13.3686 10.8624 13.6128 10.8527 13.8445 10.787L18.3765 9.5L14.9028 13.934Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04688 5V8",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.02734 5H10.0686",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.375 9.5L20.6405 10.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9081 18.594C22.9081 19.1658 22.6794 19.7142 22.2723 20.1185C21.8651 20.5229 21.313 20.75 20.7372 20.75C20.1615 20.75 19.6093 20.5229 19.2022 20.1185C18.7951 19.7142 18.5664 19.1658 18.5664 18.594C18.5664 17.4 20.0133 15 20.7372 15C21.4612 15 22.9081 17.4 22.9081 18.594Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStsFuel);
export default __webpack_public_path__ + "static/media/sts_fuel.b9852c3da2a86335e90b30b78638f83d.svg";
export { ForwardRef as ReactComponent };